import React, { Component } from 'react';
import './mainpage.css';
import './bioland.css';
import NavBar from './NavBar';

interface AboutProps {}

interface AboutState {}

class About extends Component<AboutProps, AboutState> {
  render() {
    return (
      <div className="main-page about-page">
        {/* Top Navigation */}
        <NavBar />

        {/* Hero Section */}
        <section className="bioland-hero media-hero">
          <div className="media-hero-video-background">
            <video preload="metadata" autoPlay loop muted playsInline className="media-hero-video">
              <source src={require('./assets/video/web/12721926-hd_1920_1080_24fps.mp4')} type="video/mp4" />
            </video>
          </div>
          <div className="container">
            <div className="bioland-hero-inner">
              <span className="bioland-label">Company</span>
              <h1 className="bioland-hero-title">
                About META‑365
              </h1>
              <div className="bioland-meta">
                <span>Who We Are</span>
                <span className="bioland-meta-dot">•</span>
                <span>Microsoft 365 &amp; Azure Specialists</span>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="bioland-content-section">
          <div className="container">
            <div className="bioland-content">
              <p>
                META‑365 is a specialized Microsoft technology company focused on designing and delivering
                innovative solutions on Microsoft 365 and Azure. With extensive expertise in enterprise
                architecture, cloud technologies, and digital transformation, META‑365 has successfully
                supported major European organizations, including EASA and CPVO. The company also develops and
                publishes SaaS solutions for Microsoft 365, SharePoint, Teams, Power Platform, and Azure through
                Microsoft AppSource and Azure Marketplace, helping organizations modernize collaboration,
                productivity, and business processes.
              </p>

              {/* Our Team */}
              <h2>A Multidisciplinary Team</h2>
              <p>
                Behind META‑365 is a multidisciplinary team that brings together a broad range of complementary
                skills solution and cloud architects, software engineers and developers, SharePoint and Teams
                specialists, data and security practitioners, automation and AI engineers, and Microsoft
                Certified Trainers.
              </p>
              <p>
                This mix of capabilities allows us to move fluidly from strategy and architecture through to
                hands‑on implementation, delivery, and enablement without handing work off between
                disconnected vendors.
              </p>

              {/* Experience */}
              <h2>Decades of Combined Experience</h2>
              <p>
                Our people carry decades of combined experience across the Microsoft ecosystem from
                large‑scale tenant migrations and hybrid infrastructure to custom application development,
                workflow automation, identity and governance, and performance‑critical data solutions.
              </p>
              <p>
                Having delivered for public institutions and private enterprises across Europe, we understand
                the demands of regulated, security‑conscious environments and the practical realities of getting
                complex projects into production.
              </p>
              <p>
                We combine long‑standing Microsoft engineering and training heritage with a product mindset,
                translating deep technical knowledge into reliable, scalable solutions and shipping SaaS products
                used through Microsoft's marketplaces.
              </p>

              {/* Expertise */}
              <h2>Our Expertise</h2>
              <p>
                Whatever the challenge, META‑365 brings the right combination of skills to modernize
                collaboration, streamline operations, and unlock the full potential of Microsoft 365 and Azure.
              </p>
              <div className="bioland-impact-grid">
                <div className="bioland-impact-card">
                  <h4>Cloud Architecture</h4>
                  <p>Design and implementation of secure, scalable cloud solutions aligned with business objectives.</p>
                </div>
                <div className="bioland-impact-card">
                  <h4>Security &amp; Compliance</h4>
                  <p>Identity optimization, data governance, and compliance with industry standards.</p>
                </div>
                <div className="bioland-impact-card">
                  <h4>AI Automation</h4>
                  <p>AI‑enhanced workflow automation to drive operational efficiency and innovation.</p>
                </div>
                <div className="bioland-impact-card">
                  <h4>Custom Development</h4>
                  <p>Tailored Microsoft 365 applications built to solve unique business challenges.</p>
                </div>
                <div className="bioland-impact-card">
                  <h4>Tenant Modernization</h4>
                  <p>Comprehensive Microsoft 365 tenant upgrades and optimization strategies.</p>
                </div>
                <div className="bioland-impact-card">
                  <h4>Training &amp; Enablement</h4>
                  <p>Microsoft Certified Trainers delivering hands‑on enablement across the 365, Azure and data stack.</p>
                </div>
              </div>

              {/* Closing */}
              <h2>Let's Build Together</h2>
              <p>
                As a trusted Microsoft partner, META‑365 is committed to delivering high‑quality, reliable, and
                strategic solutions that enable organizations to streamline operations, enhance productivity, and
                get more value from the tools they already use every day.
              </p>
              <p className="bioland-result">The result is simple:</p>
              <p className="bioland-result-highlight">
                The right skills, in one team, delivering solutions that last.
              </p>

              <div className="bioland-cta">
                <a
                  href="https://outlook.office.com/book/META365Bookingforademo@e-study.gr/?ismsaljsauthenabled"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cta-proof-btn"
                >
                  Schedule a Demo
                </a>
                <a href="/contactus" className="cta-proof-btn">
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="footer-grid">
              <div className="footer-column">
                <h4>Products</h4>
                <ul>
                  <li><a href="/solutions/pentities">pEntities</a>
                    <ul className="footer-subnav">
                      <li><a href="/solutions/automation">Automation Module</a></li>
                      <li><a href="/solutions/ticketing">Ticketing Module</a></li>
                      <li><a href="/solutions/hr-template">HR Module</a></li>
                      <li><a href="/solutions/case-management">Legal Module</a></li>
                      <li><a href="/solutions/hr-hub">Employee Module</a></li>
                    </ul>
                  </li>
                  <li><a href="/solutions/pshareemail">PShareEmail</a></li>
                  <li><a href="/solutions/docsearch">DocSearch Tool</a></li>
                  <li><a href="/solutions/searchassistant">Search Assistant</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Company</h4>
                <ul>
                  <li><a href="/about">About Us</a></li>
                  <li><a href="/get-started">Get Started</a></li>
                  <li><a href="/contactus">Contact Us</a></li>
                  <li><a href="/plans-pricing">Plans & Pricing</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Support</h4>
                <ul>
                  <li><a href="/knowledge">Knowledge Base</a></li>
                  <li><a href="/technical-support">Technical Support</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Contact Us</h4>
                <div className="footer-office">
                  <p className="office-name">Athens Office</p>
                  <p>365 Kifisias Avenue, Kifisia, 14561</p>
                  <p>Ground Floor, Inside the Arcade</p>
                  <p>Tel: (+30)-210-260-3764</p>
                </div>
                <div className="footer-office">
                  <p className="office-name">Thessaloniki Office</p>
                  <p>15 Nikiforou Ouranou & Minotavrou Streets</p>
                  <p>Thessaloniki, 54627, PORTO CENTER, Building G1, 3rd Floor</p>
                  <p>Tel: (+30)-231-005-3361</p>
                </div>
                <div className="footer-office">
                  <p className="office-name">Crete Office</p>
                  <p>Kisamos, Chania</p>
                  <p>Tel: (+30)-2822-051309</p>
                </div>
                <p className="footer-email">info@meta-365.com</p>
              </div>
            </div>
            <div className="footer-bottom">
              <p>&copy; 2026 Meta-365. All rights reserved.</p>
              <div className="footer-social">
                <a href="https://www.linkedin.com/company/meta-365" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><img loading="lazy" decoding="async" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='white'%3E%3Cpath%20d='M4.98%203.5C4.98%204.88%203.87%206%202.5%206S0%204.88%200%203.5%201.12%201%202.5%201s2.48%201.12%202.48%202.5zM.25%208h4.5v13H.25V8zM8.5%208h4.31v1.78h.06c.6-1.14%202.07-2.34%204.26-2.34C21.5%207.44%2022.5%2010%2022.5%2014.02V21H18v-6.1c0-1.46-.03-3.33-2.03-3.33-2.03%200-2.34%201.58-2.34%203.22V21H8.5V8z'/%3E%3C/svg%3E" alt="LinkedIn" width="18" height="18" /></a>
                <a href="https://www.facebook.com/profile.php?id=61589941284929" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><img loading="lazy" decoding="async" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='white'%3E%3Cpath%20d='M24%2012.07C24%205.4%2018.63%200%2012%200S0%205.4%200%2012.07C0%2018.1%204.39%2023.1%2010.13%2024v-8.44H7.08v-3.49h3.05V9.41c0-3.02%201.79-4.69%204.53-4.69%201.31%200%202.68.24%202.68.24v2.97h-1.51c-1.49%200-1.96.93-1.96%201.89v2.25h3.33l-.53%203.49h-2.8V24C19.61%2023.1%2024%2018.1%2024%2012.07z'/%3E%3C/svg%3E" alt="Facebook" width="18" height="18" /></a>
              </div>
              <div className="footer-links">
                <a href="/privacy-policy">Privacy Policy</a>
                <a href="/terms-of-use">Terms & Conditions</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default About;
